import { set, get } from 'lodash';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { Money } from '@/models/money';

export const saveToLocalStorage = (path: string, payload: unknown) => {
    const storageObject = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY) || '{}'
    );

    set(storageObject, path, payload);

    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storageObject));
};

export const getFromLocalStorage = <T>(path: string, defaultValue?: T): T => {
    const storageObject = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY) || '{}'
    );

    return get(storageObject, path, defaultValue) as T;
};

export const deleteFromLocalStorage = (path: string) => {
    const storageObject = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE_KEY) || '{}'
    );

    const deleted = delete storageObject[path];

    if (deleted) {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storageObject));
    }
};

export const getMoneyAsString = (money: Money) => {
    switch (money.currency) {
        case 'EUR':
            return `€${'\u00A0'}${new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(money.amount)}`;
        default:
            return money.amount;
    }
};

export const downloadContentGeneric = (filename: string, content: string) => {
    const element = document.createElement('a');

    element.setAttribute('href', content);
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
};

/**
 *
 * @param data - data base64 encoded
 * @param fileType - file type e.g. 'data:application/vnd.ms-excel;'
 */
export const createBlobFromBase64encoded = (data: string, fileType: string) => {
    const byteCharacters = atob(data);
    const byteNumbers = new Array(byteCharacters.length)
        .fill(0)
        .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], {
        type: fileType,
    });
};
